export const NON_MOBILE_DEVICE_SCREEN_TYPES = {
  SMS: 'SMS',
  QR: 'QR'
};
